import { stdObject } from "../../../data/types/stdObject";

export const docValueType = (value: string, label: string) => {
  let tempData: stdObject = { type: "", label: "" };
  switch (value) {
    case "CLI":
    case "RES":
    case "TEL":
    case "CEL":
    case "FEC2":
    case "EMA":
    case "DOM":
    case "INT":
    case "PSE":
    case "POL":
      tempData.type = "button";
      break;
    case "PRE":
    case "PIM":
    case "PAG":
    case "ENV":
    case "TAL":
    case "ALM2":
      tempData.type = "select";
      break;
    case "FEC":
    case "EST3":
    case "NOT":
      tempData.type = "text";
      break;
    default:
      if (parseInt(value) > -1) {
        tempData.type = "button";
      } else {
        return {};
      }
  }
  return {
    ...tempData,
    label,
  };
};
